import { FC, ReactNode } from 'react'
import { Box, IconButton, Typography } from '@mui/material'

import { PRIMARY_COLORS_VARIANTS, TEXT_DARK_COLORS_VARIANTS } from '@/utils/constants/colors'
import { HighlightedBoxElement } from 'components/shared/HighlightedBoxElement'
import { Autorenew } from '@mui/icons-material'

interface ProfileDrawerHighlightedItemProps {
  title: string
  description: string
  rightSlot: ReactNode
  icon?: ReactNode
  descriptionColor?: string
  onRefresh?: () => void
}

export const ProfileDrawerHighlightedItem: FC<ProfileDrawerHighlightedItemProps> = ({
  title,
  description,
  rightSlot,
  descriptionColor,
  icon,
  onRefresh,
}) => {
  return (
    <HighlightedBoxElement>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box display="flex" alignItems="center" gap={1}>
          {icon && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                p: 1.5,
                borderRadius: '100%',
                color: PRIMARY_COLORS_VARIANTS[500],
                backgroundColor: PRIMARY_COLORS_VARIANTS[400],
              }}
            >
              {icon}
            </Box>
          )}
          <Box display="flex" flexDirection="column">
            <Box display="flex" alignItems="center" gap={0.5}>
              <Typography
                variant="body2"
                fontSize="12px"
                component="div"
                textTransform="uppercase"
                color={TEXT_DARK_COLORS_VARIANTS[250]}
              >
                {title}
              </Typography>
              {onRefresh && (
                <IconButton size="small" onClick={onRefresh} sx={{ p: 0.25 }}>
                  <Autorenew sx={{ fontSize: '18px', color: PRIMARY_COLORS_VARIANTS[500] }} />
                </IconButton>
              )}
            </Box>

            <Typography
              variant="h6"
              component="div"
              fontSize="16px"
              fontWeight={800}
              sx={{ color: descriptionColor || PRIMARY_COLORS_VARIANTS[500] }}
            >
              {description}
            </Typography>
          </Box>
        </Box>
        {rightSlot}
      </Box>
    </HighlightedBoxElement>
  )
}
